import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'underscore'
import axios from 'axios'
import slugify from 'slugify'
import api from '@/api'
import constants from '@/constants'
import live from '@/live'

Vue.use(Vuex)

export default new Vuex.Store({

	modules: {
	},

	state: {
		locale: 'en',
		guide: {},
		categories: [],
		groups: [],
		texts: {},
		locations: {},
		dictionary: [],
		items: [],
		terms: [],
		category: 0,
		mobileOnly: 0,
		group: 0,
		groupFocus: 0,
		item: 0,
		location: 0,
		key: '',
		primary: 0,
		base: '',
		position: false,
		positionState: 'idle',
		drives: {}
	},

	getters: {

		locale: function(state) {

			return state.locale

		},

		guide: function(state) {

			return state.guide

		},

		mobileOnly: function(state) {

			return state.mobileOnly

		},

		categories: function(state) {

			return state.categories

		},

		'categories/find': function(state) {
		
			return function(id) {
		
				return _.findWhere(state.categories, {
					id: parseInt(id)
				})
		
			}
		
		},

		groups: function(state) {

			return state.groups

		},

		'groups/find': function(state) {
		
			return function(id) {
		
				return _.findWhere(state.groups, {
					slug: id
				})
		
			}
		
		},

		'groups/findbyid': function(state) {
		
			return function(id) {
		
				return _.findWhere(state.groups, {
					id: id
				})
		
			}
		
		},

		items: function(state) {

			return state.items

		},

		dictionary: function(state) {

			return state.dictionary

		},

		terms: function(state) {

			return state.terms

		},

		texts: function(state) {

			return state.texts

		},

		locations: function(state) {

			return state.locations

		},

		slides: function(state) {

			return state.slides

		},

		category: function(state) {

			return state.category

		},

		group: function(state) {

			return state.group

		},

		'group/focus': function(state) {

			return state.groupFocus

		},

		item: function(state) {

			return state.item

		},

		location: function(state) {

			return state.location

		},

		key: function(state) {

			return state.key

		},

		base: function(state) {

			return state.base

		},

		position: function(state) {

			return state.position

		},

		// resolved driving distance/time per location id for the current origin;
		// the distance line displays these road miles, so the closest-first sort
		// keys off them too (see mixin/blocksort)
		drives: function(state) {

			return state.drives

		}

	},

	mutations: {

		locale: function(state, value) {

			state.locale = value

		},

		key: function(state, value) {

			state.key = value

		},

		primary: function(state, value) {

			state.primary = value

		},

		mobileOnly: function(state, value) {

			state.mobileOnly = value

		},

		guide: function(state, value) {

			Vue.set(state, 'guide', value)

		},

		category: function(state, value) {

			state.category = value

		},

		group: function(state, value) {

			state.group = value

		},

		'group/focus': function(state, value) {

			state.groupFocus = value

		},

		item: function(state, value) {

			state.item = value

		},

		location: function(state, value) {

			state.location = value

		},

		position: function(state, value) {

			state.position = value

			// origin changed - previously resolved drive distances no longer apply
			state.drives = {}

		},

		positionState: function(state, value) {

			state.positionState = value

		},

		drive: function(state, value) {

			Vue.set(state.drives, value.id, value.result)

		}

	},

	actions: {

		// asks the browser for the visitor's position the first time a view
		// renders a location that has coordinates; cached for the session so
		// the permission prompt and lookup only happen once
		locate: function(context) {

			if (context.state.positionState !== 'idle') return

			context.commit('positionState', 'pending')

			// an address entered in the recyclebycity.com scheduler is carried
			// over (same-origin localStorage) and takes precedence over the
			// browser geolocation prompt
			try {

				var scheduled = JSON.parse(localStorage.getItem('rbc-location'))

				if (scheduled && typeof scheduled.lat === 'number' && typeof scheduled.lng === 'number' && scheduled.time > Date.now() - 86400000) {

					context.commit('position', { lat: scheduled.lat, lng: scheduled.lng })
					context.commit('positionState', 'granted')

					return

				}

			} catch (e) {

				// ignore unreadable scheduler address

			}

			try {

				var cached = JSON.parse(sessionStorage.getItem('rbc-position'))

				if (cached && cached.time > Date.now() - 600000) {

					context.commit('position', { lat: cached.lat, lng: cached.lng })
					context.commit('positionState', 'granted')

					return

				}

			} catch (e) {

				// ignore unreadable cache

			}

			if (!navigator.geolocation) {

				context.commit('positionState', 'denied')

				return

			}

			navigator.geolocation.getCurrentPosition(function(result) {

				var position = {
					lat: result.coords.latitude,
					lng: result.coords.longitude
				}

				try {

					sessionStorage.setItem('rbc-position', JSON.stringify({
						lat: position.lat,
						lng: position.lng,
						time: Date.now()
					}))

				} catch (e) {

					// storage unavailable

				}

				context.commit('position', position)
				context.commit('positionState', 'granted')

			}, function() {

				context.commit('positionState', 'denied')

			}, {
				timeout: 8000,
				maximumAge: 300000
			})

		},

		init: function(context, e) {

			context.commit('key', e.key)
			context.commit('primary', e.primary)

			axios.defaults.headers.common['rbc-guide'] = e.key

			live.init()

			live.$on('updated', function() {

				context.dispatch('load')

			})

			return context.dispatch('load')
	
		},

		load: function(context) {

			return new Promise(function(resolve) {

				var params = {}

				if (context.state.primary) params.primary = context.state.primary
					
				api.get('guide/' + context.getters['key'], params).then(function(response) {

					context.state.categories = response.categories
					Vue.set(context.state, 'guide', response.guide)
					context.state.groups = response.groups
					context.state.items = response.items
					context.state.texts = response.texts
					context.state.locations = response.locations
					context.state.base = response.base

					var terms = []
					var dictionary = []

					_.each({
						//category: 'categories',
						group: 'groups',
						item: 'items'
						//location: 'locations'
					}, function(store, key) {
		
						_.each(context.getters[store], function(item) {

							var title = slugify(item.title, {
								replacement: ' ',
								remove: /[*+~.()'"!:@]/g,
								strict: true,
								lower: true
							})
		
							terms.push({
								id: item.id,
								text: title,
								type: constants.type[key]
							})

							_.each(title.split(' '), function(part) {

								dictionary.push(part)

							})
		
							_.each(item.terms, function(term) {

								term = slugify(term, {
									replacement: ' ',
									remove: /[*+~.()'"!:@]/g,
									strict: true,
									lower: true
								})
		
								terms.push({
									id: item.id,
									text: term,
									type: constants.type[key]
								})

								_.each(term.split(' '), function(part) {
	
									dictionary.push(part)
	
								})
		
							})
		
						})
		
					})

					context.state.terms = terms
					context.state.dictionary = dictionary
		
					if (!context.state.category) context.state.category = response.categories[0].id

					resolve()

				})

			})

		}

	}

})
